module.exports = __webpack_public_path__ + "static/media/Picture-perfect-Web-Weddings .8854d5cf.webp";